<template>
  <dl>
    <dd class="info">
      <span class="label">{{ orgDst.airlineName }} {{
        orgDst.flightNo
      }}</span>
      <span class="txt">{{ orgDst.departureDate }}&nbsp;&nbsp;{{
        orgDst.departureDate | format('dddd')
      }}</span>
    </dd>
    <div class="detail-item">
      <div class="class" v-if="airline === 'JD' && serviceClass && serviceClassMap[serviceClass]">{{ serviceClassMap[serviceClass] }}</div>
      <dd class="detail">
        <div>
          <span class="label">{{ orgDst.departureTime | format('HH:mm') }}</span>
          <span class="txt">{{ orgDst.departureAirPortName }}{{
            orgDst.departureTerminal
          }}</span>
        </div>
        <div v-if="orgDst.stopAirportName">
          <span class="label"></span>
          <span class="txt">经停 {{ orgDst.stopAirportName }}{{
            orgDst.stopTerminal || ''
          }}</span>
        </div>
        <div>
          <span class="label">{{ orgDst.arrivalTime | format('HH:mm') }}<span class="gt-day">{{
            orgDst | gtDay
          }}</span></span>
          <span class="txt">{{ orgDst.arrivalAirPortName }}{{
            orgDst.arrivalTerminal
          }}</span>
        </div>
      </dd>
    </div>
  </dl>
</template>
<script>
import { serviceClassMap } from '@/dicts/common.js'

const mainSettings = window.__MICRO_ROOT__ ?? {}

export default {
  props: {
    orgDst: Object,
    serviceClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      airline: mainSettings?.airline,
      serviceClassMap
    }
  }
}
</script>
<style lang="less" scoped>
.detail-item {
  display: flex;
  align-items: center;
  .class {
    margin-right: 10px;
  }
}
</style>
